export enum LoanPaymentKind {
  /// <summary>
  /// با اولین قسط
  /// </summary>
  WithFirstPament = 1,
  /// <summary>
  /// با آخرین قسط
  /// </summary>
  WithLastPayment = 2,
  /// <summary>
  /// در اولین قسط
  /// </summary>
  FirstPayment = 3,
  /// <summary>
  /// در آخرین قسط
  /// </summary>
  LastPayment = 4,
}
